// extracted by mini-css-extract-plugin
export default {"form-select":"innerSelectForForm_form-select__tXdto","red-dot":"innerSelectForForm_red-dot__m+JDL","error-border":"innerSelectForForm_error-border__pjWpV"};